export default {
  PROJECT_UNITS_SUMMARY_SET_LOADING: 'PROJECT_UNITS_SUMMARY_SET_LOADING',

  PROJECT_UNITS_SUMMARY_REQUEST: 'PROJECT_UNITS_SUMMARY_REQUEST',
  PROJECT_UNITS_SUMMARY_FAILURE: 'PROJECT_UNITS_SUMMARY_FAILURE',
  PROJECT_UNITS_SUMMARY_SUCCESS: 'PROJECT_UNITS_SUMMARY_SUCCESS',

  PROJECT_UNITS_SUMMARY_RESET: 'PROJECT_UNITS_SUMMARY_RESET',
};
